import React, { useState, useRef, useEffect } from 'react';
import api from './api/client';
import * as XLSX from 'xlsx';
import HeaderLogged from './components/header_logged';
import DataTable from './components/DataTable';
import Container from './components/container';
import Tabs from './components/Tabs';
import TableTittle from './components/TableTittle';
import SearchAndFilter from './components/SearchAndFilter';
import Icons from './components/icons';
import Popup from './components/Popup';
import AddForm from './components/AddForm';
import { API_URL } from './config'
import DataTableWithExpandableRows from './components/DataTableWithExpandableRows';
import SecondaryTable from './components/SecondaryTable';
import DynamicInventoryTable from './components/DynamicInventoryTable'
import PlanningPopup from './components/PlanningPopup';
import UniversalDataTable from './components/UniversalDataTable';
import AmazonShipmentsPopup from './components/AmazonShipmentsPopup';
import EditAmazonShipmentPopup from './components/EditAmazonShipmentPopup';
import CarriersPopup from './components/CarriersPopup';

const ShipmentsPage = () => {
    // Конфигурация фильтров
    const filtersConfig = {};
    const [filterParams, setFilterParams] = useState(() => {
        const initialFilters = {};
        for (const tab in filtersConfig) {
            filtersConfig[tab].forEach(filter => {
                if (filter.defaultValue) {
                    initialFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        return initialFilters;
    });
    const setDefaultFilters = () => {
        const defaultFilters = {};
        if (Array.isArray(filtersConfig[activeTab])) {
            filtersConfig[activeTab].forEach(filter => {
                if (filter.defaultValue) {
                    defaultFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        setFilterParams(defaultFilters);
    };
    
    useEffect(() => {
        setDefaultFilters();
    }, []);
    const [searchTerm, setSearchTerm] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupFields, setPopupFields] = useState([]);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupSubtitle, setPopupSubtitle] = useState('');
    const [updateKey, setUpdateKey] = useState(0);
    const [activeTab, setActiveTab] = useState('scannershipments');
    const [data, setData] = useState([]);
    const tableRefs = useRef({});
    const [showPlanningPopup, setShowPlanningPopup] = useState(false);
    const [isAmazonPopupOpen, setIsAmazonPopupOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editShipmentData, setEditShipmentData] = useState(null);
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [showCompletedShipments, setShowCompletedShipments] = useState(false);
    const [isCarriersPopupOpen, setIsCarriersPopupOpen] = useState(false);

    const toggleCompletedShipments = () => {
        setShowCompletedShipments(prev => !prev);
    };

    const keyFieldsConfig = {
        sets: 'SKU',
        brands: 'brandID',
        containers: 'containerID',
        seeds: 'seedsID',
        setscomposition: ['setSKU', 'sbSKU'],
        seedscategory: 'categoryID',
        employees: 'employeeID',
        emplphones: 'employeeID',
        empladdresses: 'employeeID',
        individualpackets: 'SKU',
        sbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        mbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        whlocations: 'location',
        seedslocationwh: ['seedsID', 'bagnumid'],
        masterbagsinventory: 'sku',
        smallbagsinventory: 'sku',
        individualpacketsinventory: 'SKU',
        setsInventory: 'SKU',
        wildmicr: 'SKU',
        wildmicrinventory: 'SKU',
        wildmicrproduction: ['SKU', 'emplID', 'prodDate', 'shift'],
        wildmicrmasterbagsinventory: 'sku',
        minitoolsinventory: 'brandID',
        silicagelinventory: 'brandID',
        shipmentsfbamb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentsfbafb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentssbss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentsssmb: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrfba: ['brandID', 'shipmentID','SKU', 'shipmentDate'],
        workperformance: ['employeeID', 'workday', 'shift'],
        materialsuppliers: ['supplierID'],
        seedssuppliers: ['supplierID'],
        smallbagsorder: ['sku', 'orderDate'],
        masterbagsorder: ['sku','orderDate'],
        seedsorders: ['seedsID', 'supplierID', 'orderdate'],
        silicabagsorders: ['brandID', 'orderDate'],
        toolsorders: ['brandID', 'orderDate'],
        wmmasterbagsorder: ['sku','orderDate'],
        scannershipments: ['sku', 'box'],
        amz_shipments: ['ShipmentID'],
    };

    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);
    };

    const handleFilter = (params) => {
        setFilterParams(params);
        fetchTabData(`/api/${activeTab}`, params);
    };

    const handleEdit = (data, id) => {
        const tableName = activeTab;
        if (activeTab === 'amazon-shipments') {
            api.get(`/api/edit-amz-shipments/${id}`)
              .then(response => {
                setEditData({
                  shipmentID: response.data.shipmentID,
                  pickupDate: response.data.pickupDate,
                  pickupDateFact: response.data.pickupDateFact,
                  marketplace: response.data.marketplace,
                  skus: response.data.skus || [],
                  statusID: response.data.statusID 
                });
                setIsEditPopupOpen(true);
              })
            .catch(error => {
              console.error('Error fetching shipment data:', error);
            });
        } else {
          const fields = tabs.find(tab => tab.name === tableName).fields.map(field => ({
            ...field,
            value: data[field.name],
          }));
          const keyFields = keyFieldsConfig[tableName];
          const initialKeyValues = Array.isArray(keyFields) ? keyFields.reduce((acc, key) => {
            acc[key] = data[key];
            return acc;
          }, {}) : { [keyFields]: data[keyFields] };
          setPopupData({ ...data, tableName, id, initialKeyValues });
          setPopupFields(fields);
          setPopupTitle(`Edit ${tableName}`);
          setPopupSubtitle(`Edit ${tableName} details`);
          setIsPopupOpen(true);
        }
    };

    // AmazonShipmentsPopup sends an array (one CSV may hold several shipments),
    // EditAmazonShipmentPopup sends a single object.
    const handleAmazonPopupSubmit = async (payload) => {
        const list = Array.isArray(payload) ? payload : [payload];
        try {
            for (const data of list) {
                const url = `/api/amz-shipments${editData ? `/${data.shipmentID}` : ''}`;
                const method = editData ? 'put' : 'post';

                await api({
                    method,
                    url,
                    data: {
                        shipmentID: data.shipmentID,
                        pickupDate: data.pickupDate,
                        pickupDateFact: data.pickupDateFact,
                        marketplace: data.marketplace,
                        skus: data.skus,
                        statusID: editData ? undefined : 1,
                    },
                });

                if (data.statusID === 5) {
                    await api.put(`/api/update-shipment-status`, {
                        shipmentID: data.shipmentID,
                        statusID: 5
                    });
                }
            }

            setUpdateKey(prevKey => prevKey + 1);
            setIsAmazonPopupOpen(false);
            setIsEditPopupOpen(false);
            
            if (activeTab === 'amazon-shipments') {
                const [newData] = await Promise.all([
                    api.get(`/api/amz-shipments`),
                ]);
                setData(newData.data);
            }
        } catch (error) {
            console.error('Error saving shipment data:', error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
        setPopupFields([]);
    };

    const handlePopupSubmit = async (event) => {
        event.preventDefault();
        const updateData = popupFields.reduce((acc, field) => {
            acc[field.name] = field.value;
            return acc;
        }, {});

        try {
            const tableName = popupData.tableName;
            const keyFields = keyFieldsConfig[tableName];
            const isEditMode = !!popupData.id;

            let url;
            let method;
            let currentKeys;

            if (isEditMode) {
                currentKeys = popupData.initialKeyValues;
                if (Array.isArray(keyFields)) {
                    const id = keyFields.map(key => `${key}=${currentKeys[key]}`).join('&');
                    url = `/api/${tableName}?${id}&currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
                    method = 'put';
                } else {
                    const id = currentKeys[keyFields];
                    url = `/api/${tableName}/${id}?currentKeys=${encodeURIComponent(JSON.stringify(currentKeys))}`;
                    method = 'put';
                }
            } else {
                url = `/api/${tableName}`;
                method = 'post';
            }

            const response = await api({
                method,
                url,
                data: updateData
            });

            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error(`Error data:`, error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const handleFieldChange = (index, event) => {
        const newFields = [...popupFields];
        newFields[index].value = event.target.value;
        const updatedData = { ...popupData, [newFields[index].name]: event.target.value };
        setPopupFields(newFields);
        setPopupData(updatedData);
    };

    const handleAddClick = () => {
        if (activeTab === 'amazon-shipments') {
            setEditData(null);
            setIsAmazonPopupOpen(true);
        } else if (activeTab === 'planning') {
            setShowPlanningPopup(true);
        } else {
            const fields = tabs.find(tab => tab.name === activeTab).fields.map(field => ({
                ...field,
                value: ''
            }));
            setPopupData({ tableName: activeTab });
            setPopupFields(fields);
            setPopupTitle(`Add New ${activeTab}`);
            setPopupSubtitle(`Add new ${activeTab} details`);
            setIsPopupOpen(true);
        }
    };

    const handlePlanningSubmit = async (entries) => {
        try {
            const response = await api.post(`/api/shipping_plan`, entries);
            setShowPlanningPopup(false);
            setUpdateKey(prev => prev + 1);
        } catch (error) {
            console.error('Error adding planning data:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            await api.delete(`/api/amz-shipments?ShipmentID=${id}`);
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error deleting shipment:', error);
        }
    };

    const handleAddSubmit = async (event) => {
        event.preventDefault();
        try {
            const newData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

            const tableName = popupData.tableName;
            const response = await api.post(`/api/${tableName}`, newData);
            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error adding data:', error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const fetchTabData = async (endpoint) => {
        try {
            const response = await api.get(endpoint, {
                params: {
                    page: 1,
                    limit: 100,
                    search: searchTerm,
                    ...filterParams
                }
            });
            setData(response.data.items);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }
    };

    const tabs = [
        {
            name: 'scannershipments',
            label: 'Shipments',
            fields: [
                { label: 'Product Name', name: 'setname', type: 'text', readonly: true },
                { label: 'Box', name: 'box', type: 'text' },
                { label: 'Date', name: 'date', type: 'text' },
                { label: 'Destination', name: 'destination', type: 'text' },
                { label: 'QTY', name: 'qty', type: 'text' },
            ],
            content: (
                <DataTableWithExpandableRows
                    columns={[
                        { key: 'sku', label: 'SKU' },
                        { key: 'setname', label: 'Product' },
                        { key: 'box_count', label: 'Boxes QTY' },
                        { key: 'total_qty', label: 'Sets QTY' },
                        { key: 'last_shipped_date', label: 'Last Shipped Date' },
                    ]}
                    endpoint={`${API_URL}/api/scannershipments`}
                    secondaryTableConfig={{
                        endpointBase: `${API_URL}/api/scannershipmentsdetails`,
                        columns: [
                            { key: 'box', label: 'Box ID' },
                            { key: 'sku', label: 'SKU' },
                            { key: 'setname', label: 'Product' },
                            { key: 'qty', label: 'QTY' },
                            { key: 'destination', label: 'Destination' },
                            { key: 'added_date', label: 'Date Added' },
                        ],
                        enableHistory: false,
                    }}
                    keyFieldsConfig={['sku', 'box']}
                    onEdit={handleEdit}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                />
            ),
        },
        {
            name: 'planning',
            label: 'Shipments Calculator',
            content: (
                <DynamicInventoryTable
                    inventoryEndpoint={`${API_URL}/api/allproductsstock`}
                    planningEndpoint={`${API_URL}/api/shipping_plan`}
                    dateField="plan_date"
                    qtyField="qty_boxes"
                    baseColumns={[
                        { key: 'sku', label: 'SKU', sortable: true },
                        { key: 'productName', label: 'Product Name', sortable: true },
                        { key: 'box_count', label: 'Available Boxes' },
                        { key: 'total_qty', label: 'Sets QTY' }
                    ]}
                    showActions={false}
                />
            )
        },
        {
            name: 'amazon-shipments',
            label: 'Marketplace Shipments',
            fields: [],
            content: (
                <UniversalDataTable
                    columns={[
                        { label: 'Shipment ID', key: 'ShipmentID' },
                        { label: 'Marketplace', key: 'marketplace' },
                        { label: 'Carrier', key: 'carrier_name' },
                        { label: 'SKU QTY', key: 'sku_count' },
                        { label: 'Pickup Date Plan', key: 'pickup_date' },
                        { label: 'Pickup Date Fact', key: 'pickup_date_fact' },
                        { label: 'Date Created', key: 'create_date' },
                        { label: 'Boxes QTY', key: 'boxes_needed' },
                        { label: 'Boxes Added', key: 'boxes_added' },
                        { label: 'Status', key: 'statusName' },
                    ]}
                    endpoint={`${API_URL}/api/amz-shipments`}
                    secondaryTableConfig={{
                        endpointBase: `${API_URL}/api/amz-shipments-details`,
                        columns: [
                            { key: 'ShipmentID', label: 'ID' },
                            { key: 'sku', label: 'SKU' },
                            { key: 'ASIN', label: 'ASIN' },
                            { key: 'boxes_stock', label: 'Stock Boxes' },
                            { key: 'boxes_needed', label: 'Boxes Needed' },
                            { key: 'boxes_added', label: 'Boxes Added' },
                            { key: 'sets_needed', label: 'Sets Per Shipment' },
                        ],
                        enableEdit: false,
                        enableDelete: false,
                        enableHistory: false
                    }}
                    keyFieldsConfig={keyFieldsConfig}
                    tableName="amz_shipments"
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    enableEdit={true}
                    enableDelete={true}
                    updateKey={updateKey}
                    showCompletedShipments={showCompletedShipments}
                    toggleCompletedShipments={toggleCompletedShipments}
                />
            ),
        },
    ];

    return (
        <>
            <Icons />
            <HeaderLogged />
            <Container>
                <style>
                    {`
                        .checkbox-container {
                            margin: 15px 0;
                            padding: 10px;
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                            font-size: 14px;
                            color: #333;
                        }

                        .checkbox-container label {
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            user-select: none;
                            transition: color 0.2s ease;
                        }

                        

                        .checkbox-container input[type="checkbox"] {
                            appearance: none;
                            width: 18px;
                            height: 18px;
                            border: 2px solid #ccc;
                            border-radius: 4px;
                            background-color: #fff;
                            cursor: pointer;
                            position: relative;
                            transition: border-color 0.2s ease, background-color 0.2s ease;
                        }

                        .checkbox-container input[type="checkbox"]:checked {
                            border-color: #28a745;
                            background-color: #28a745;
                        }

                        .checkbox-container input[type="checkbox"]:checked::after {
                            content: '✔';
                            color: #fff;
                            font-size: 12px;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }

                        
                    `}
                </style>
                <TableTittle
                    sectionTitle="Shipments"
                    sectionSubtitle="Manage shipment details"
                    onAddClick={handleAddClick}
                    activeTab={activeTab}
                    tableRefs={tableRefs}
                    onCarriersClick={() => setIsCarriersPopupOpen(true)}
                />
                <SearchAndFilter
                    placeholder="Search by date, employee name, seeds..."
                    onSearch={handleSearch}
                    onFilter={handleFilter}
                    filtersConfig={filtersConfig[activeTab] || []}
                />
                {activeTab === 'amazon-shipments' && (
                    <div className="checkbox-container">
                        <label>
                            <input
                                type="checkbox"
                                checked={showCompletedShipments}
                                onChange={toggleCompletedShipments}
                            />
                            Show Completed Shipments
                        </label>
                    </div>
                )}
                <Tabs
                    tabs={tabs}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    tableRefs={tableRefs}
                />
            </Container>
            {popupData && (
                <Popup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    title={popupTitle}
                    subtitle={popupSubtitle}
                    fields={popupFields}
                    onFieldChange={handleFieldChange}
                    onSubmit={handlePopupSubmit}
                />
            )}
            {showPlanningPopup && (
                <PlanningPopup
                    isOpen={showPlanningPopup}
                    onClose={() => setShowPlanningPopup(false)}
                    onSubmit={handlePlanningSubmit}
                />
            )}
            <AmazonShipmentsPopup
                isOpen={isAmazonPopupOpen}
                onClose={() => setIsAmazonPopupOpen(false)}
                onSubmit={handleAmazonPopupSubmit}
                editData={editData}
            />
            <EditAmazonShipmentPopup
                isOpen={isEditPopupOpen}
                onClose={() => setIsEditPopupOpen(false)}
                onSubmit={handleAmazonPopupSubmit}
                shipmentData={editData}
            />
            <CarriersPopup
                isOpen={isCarriersPopupOpen}
                onClose={() => setIsCarriersPopupOpen(false)}
            />
        </>
    );
};

export default ShipmentsPage;